import { connect } from 'react-redux';

import {
  addAnswer,
  changeAnswer,
  changeLikeState, getQuestionnaire,
  revertLastQuestion,
  saveQuestionnairesResults,
  toggleLike
} from '../actions/questionnaires';

import Voting from '../scenes/Voting';

const mapStateToProps = ({ voting }, { match }) => {
  const { id } = match.params;
  const questionnaire = voting.currentQuestionnaire;
  const questionnaireMeta = voting.meta[id];
  return {
    questionnaire,
    meta: questionnaireMeta,
    voteDate: voting.voteDate,
    loading: voting.loading
  };
};

const mapDispatchToProps = (dispatch, { match }) => {
  const { id: questionnaireId } = match.params;
  return {
    getQuestionnaire: () => {
      dispatch(getQuestionnaire(questionnaireId))
    },
    saveQuestionnairesResults: content => {
      dispatch(saveQuestionnairesResults(questionnaireId, content));
    },
    addAnswer: answer =>
      dispatch(
        addAnswer({
          answer,
          questionnaireId
        })
      ),
    changeAnswer: (questionId, answer) =>
      dispatch(
        changeAnswer({
          answer,
          questionnaireId,
          questionId
        })
      ),
    toggleLike: () =>
      dispatch(
        toggleLike({
          questionnaireId
        })
      ),
    changeLikeState: questionId => dispatch(changeLikeState(questionnaireId, questionId)),
    revert: () => dispatch(revertLastQuestion({ questionnaireId })),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Voting);
